export const groupIndexes = [
  1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15,
] as const
export type GroupIndex = (typeof groupIndexes)[number]

export const groups = [
  'group1',
  'group2',
  'group3',
  'group4',
  'group5',
  'group6',
  'group7',
  'group8',
  'group9',
  'group10',
  'group11',
  'group12',
  'group13',
  'group14',
  'group15',
] as const
export type Group = (typeof groups)[number]

export type GroupAll = 'all'
export const groupAllLabelI18nKey = 'overall_7' as const

export const groupsAndAll = ['all', ...groups] as const
export type GroupAndAll = Group | GroupAll

/**
 * GroupIndex を Group に変換します。
 *
 * @param groupIndex - GroupIndex。
 * @returns Group。
 */
export const toGroup = (groupIndex: GroupIndex): Group => `group${groupIndex}`

/**
 * Group を GroupIndex に変換します。
 *
 * @param group - Group。
 * @returns GroupIndex。
 */
export const toGroupIndex = (group: Group): GroupIndex =>
  Number(group.replace('group', '')) as GroupIndex

/**
 * 2つの Group を比較します。
 *
 * @param a - 1つ目の Group。
 * @param b - 2つ目の Group。
 * @returns a が b より小さい場合は負の整数、a が b より大きい場合は正の整数、a と b が等しい場合は 0。
 */
export const compareGroup = (a: Group, b: Group): number =>
  toGroupIndex(a) - toGroupIndex(b)
